import styled from 'styled-components'

export const ModalConfirmationStyle = styled.div`
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ theme }) => {
    return theme.colors.shadow
  }};

  section {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    margin: 10px;
    background-color: ${({ theme }) => {
      return theme.colors.trueWhite
    }};
    border-radius: ${({ theme }) => {
      return theme.borderRadius.normal
    }};
    h3 {
      text-align: center;
      font-size: ${({ theme }) => {
        return theme.fonts.size.big
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin
      }};
      color: ${({ theme }) => {
        return theme.colors.darkPrimary
      }};
      border-bottom: ${({ theme }) => {
        return theme.border
      }};
      padding: 0 0 2px 0;
      margin: 0 0 2px 0;
    }
    p {
      font-size: ${({ theme }) => {
        return theme.fonts.size.normal
      }};
      font-weight: ${({ theme }) => {
        return theme.fonts.weight.thin
      }};
      color: ${({ theme }) => {
        return theme.colors.black
      }};
      margin: 0 0 5px 0;
    }
  }
`

export const WrapperButtonsModal = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 5px;
  @media screen and (max-width: 720px) {
    flex-direction: column;
  }
`

export const ButtonModal = styled.button`
  padding: 5px;
  color: ${({ theme }) => {
    return theme.colors.white
  }};
  font-family: inherit;
  font-size: ${({ theme }) => {
    return theme.fonts.size.normal
  }};
  font-weight: ${({ theme }) => {
    return theme.fonts.weight.thin
  }};
  background-color: ${({ theme }) =>
    ({ typeButton }: { typeButton: number }) => {
      if (typeButton === 1) {
        return theme.colors.error
      } else if (typeButton === 2) {
        return theme.colors.success
      }
    }};
  border: none;
  border-radius: ${({ theme }) => {
    return theme.borderRadius.small
  }};
  cursor: pointer;
  transition: background-color 200ms ease-in-out;
  &:hover {
    background-color: ${({ theme }) =>
      ({ typeButton }: { typeButton: number }) => {
        if (typeButton === 1) {
          return theme.colors.darkError
        } else if (typeButton === 2) {
          return theme.colors.darkSuccess
        }
      }};
  }
  &:disabled {
    background-color: ${({ theme }) => {
      return theme.colors.border
    }};
    cursor: not-allowed;
  }

  @media screen and (max-width: 720px) {
    margin: 5px 0;
  }
`
